module.exports = __webpack_public_path__ + "img/9788932035550.c1431108.jpg";